import notification from './notification';
import noPermissionsMessage from '../views/tools/noPermissionsMessage';

export default {
    mixins: [notification],
    components: {
        'no-permission-message' : noPermissionsMessage
    },
    data() {
        return {
            permissionTypes: {
                agreementRead: 'agreement-read',
                invoiceRead: 'invoice-read',
                mediaWrite: 'media-write',
                websiteWrite: 'website-write',
                integrationWrite: 'integration-write',
                billingRead: 'billing-read',
                billingWrite: 'billing-write',
                userRead: 'user-read',
                userWrite: 'user-write',
                apiRead: 'api-read',
                apiWrite: 'api-write',
                websiteWriteSpecific: 'website-write-specific',
                websiteReadSpecific: 'website-read-specific',
            },
        }
    },

    methods: {
        checkPermission(permission) {
            return this.$store.getters.checkPermissions(permission)
        },

        checkSidebarPermission(permission, sidebarItemTitle, permissionTitle) {
            return !(sidebarItemTitle === permissionTitle && !this.checkPermission(this.permissionTypes.userRead))
        },

        checkWebsitePermission(permission, websiteId) {
            if (this.$store.getters.checkPermissions(this.permissionTypes.websiteWrite)) {
                return true;
            } else if (this.$store.getters.checkSpecificPermission(this.permissionTypes.websiteWriteSpecific, websiteId)) {
                return true;
            } else if(permission === (this.permissionTypes.websiteReadSpecific)) {
                return this.$store.getters.checkSpecificPermission(this.permissionTypes.websiteReadSpecific, websiteId)
            }

            return false
        }
    },
}
